import React from 'react';
import PropTypes from 'prop-types';
import {Avatar} from "material-ui";
import Dropzone from 'react-dropzone';
import TypeInfo from './TypeInfo/TypeInfo';
import styles from './TypeFull.css';
import style from '../../../styles/styles';

class TypeFull extends React.Component {

    static propTypes = {
        app: PropTypes.object.isRequired,
        type: PropTypes.object.isRequired,
        postPicture: PropTypes.func.isRequired
    };

    static supportedDropFiles = 'image/jpeg, image/png';

    handlePictureDrop = (accepted, rejected) => {
        this.setState({uploadingFiles: []});

        accepted.forEach((picture) => {
            console.log('Uploading file ' + picture.name);
            this.props.postPicture(this.props.app.id, this.props.type.id, picture, (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                const uploadingState = this.state.uploadingFiles.filter((mediaPercent) => mediaPercent.media !== picture);
                console.log(picture.name + ' -> ' + percentCompleted + '% (' + progressEvent.loaded + ' / ' + progressEvent.total + ')');
                this.setState({
                    uploadingFiles: [
                        ...uploadingState,
                        {
                            picture: picture,
                            percent: percentCompleted
                        }
                    ]
                });
            });
        });
    };

    render() {
        const {type} = this.props;

        return (
            <div>
                <Dropzone
                    ref={(node) => {
                        this.dropzoneRef = node
                    }}
                    accept={TypeFull.supportedDropFiles}
                    onDrop={this.handlePictureDrop}
                    multiple={false}
                    style={{ }}
                >
                    <Avatar
                        icon={this.props.type.picture && <img src={this.props.type.picture} alt="" style={style.image.contain}/>}
                        size={75}
                        backgroundColor={type.color}
                        style={styles.avatar}
                    />
                </Dropzone>
                <div className="row">
                    <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                        <TypeInfo type={type}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default TypeFull;



// WEBPACK FOOTER //
// src/components/type/TypeFull/TypeFull.js